import { Dir } from 'beans'

class SystemDir extends Dir {
}

export default SystemDir